<template lang="pug">
div
  ShareImageModal(
    :visible="showShareModal"
    @close="showShareModal = false"
    :prizeName="sharePrize.prizeName"
    :icon="sharePrize.icon"
    :imgRadio="4"
  )
  //- 日日抽中奖弹
  .winning-dialog-container(
    v-if="show && winningData.prizes && winningData.prizes.length"
    v-scroll-lock="show"
  )
    .shadow(@click="close" @touchmove.prevent)
    .dialog-content
      .box
        .title 会员日日抽 {{ winningData.batchNo || '' }}
        .box-content(v-if="winningData.prizes && winningData.prizes.length > 0")
          .winning-one(v-if="winningData.prizes.length == 1")
            img.logo(:src="winningData.prizes[0].icon || ''")
            .text {{ winningData.prizes[0].prizeName || '' }}
          .winning-two(v-else-if="winningData.prizes.length == 2")
            .item(v-for="(item, index) in winningData.prizes" :key="index")
              img.logo(:src="item.icon || ''")
              .text {{ item.prizeName || '' }}
          .winning-multi(v-else)
            .item(v-for="(item, index) in winningData.prizes" :key="index")
              img.logo(:src="item.icon || ''")
              .text {{ item.prizeName || '' }}
      .btn-container
          .btn.view(@click="jumpUrl") 去查看
          .btn.share(@click="share") 分享喜悦
      .close(@click="close")
    Lottie.lottie(url="https://m.hellobike.com/resource/gallery/350/3zQc7ZIZ_data.json")
</template>
<script>
import Lottie from '@/components/lottie';
import config from '@/const/config';
import { Navigator } from '@hb/h5-navigator';
import { ParamsUtil } from '@/utils/params';
import ShareImageModal from './share-image-modal.vue';

export default {
  components: {
    Lottie,
    ShareImageModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    winningData: {
      type: Object,
      default: () => ({}),
    },
    currentOrderOptType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      actived: false,
      showShareModal: false,
    };
  },
  computed: {
    sharePrize() {
      const prizes = this.winningData.prizes || [];
      return [...prizes].sort((a, b) => b.worth - a.worth)[0] || {};
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    },
    jumpUrl() {
      const recordUrl = `https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env === 'dev' ? 'fat' : config.env}/`}latest/index.html#/vip/v3/lotteryRecord`;
      // const recordUrl = 'http://172.17.179.122:1024/#/vip/v3/lotteryRecord';
      const url = ParamsUtil.addParams(recordUrl, {
        campaignCode: (this.winningData && this.winningData.campaignCode) || '',
        batchNo: this.winningData.batchNo || '',
        currentOrderOptType: this.currentOrderOptType !== undefined ? this.currentOrderOptType : null,
      });
      Navigator.go(url);
    },
    share() {
      this.showShareModal = true;
    },
  },
};
</script>

<style lang="less" scoped>
.winning-dialog-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;

  .lottie {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    pointer-events: none;
  }

  .shadow {
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.7;
    position: absolute;
    left: 0;
    top: 0;
  }

  .dialog-content {
    position: relative;
    width: 3.03rem;
    height: 3.91rem;
    z-index: 1;

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 3.03rem;
      height: 3.18rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/hTXlZYpC_dialog2.png);
      background-size: 100%;
      background-repeat: no-repeat;
      padding-top: 0.87rem;

      .box-content {
        margin-top: 0.05rem;
        width: 2.15rem;
        height: 1.98rem;

        .winning-one {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          padding-top: 0.24rem;

          .logo {
            width: 1rem;
            height: 1rem;
            object-fit: contain;
          }

          .text {
            max-width: 1.83rem;
            margin-top: 0.08rem;
            font-weight: 500;
            font-size: 0.12rem;
            color: #242729;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .winning-two {
          display: flex;
          justify-content: space-between;
          padding: 0.4rem 0.14rem 0;
          width: 100%;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .logo {
              width: 0.8rem;
              height: 0.8rem;
              object-fit: contain;
            }

            .text {
              max-width: 0.8rem;
              font-weight: 500;
              font-size: 0.12rem;
              color: #242729;
              margin-top: 0.08rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .winning-multi {
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          padding: 0.4rem 0 0 0.14rem;
          overflow-x: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;

          &::-webkit-scrollbar {
            display: none;
          }

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-right: 0.14rem;

            .logo {
              width: 0.8rem;
              height: 0.8rem;
              object-fit: contain;
            }

            .text {
              max-width: 0.8rem;
              font-weight: 500;
              font-size: 0.12rem;
              color: #242729;
              margin-top: 0.08rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }

      .title {
        font-weight: 600;
        font-size: 0.14rem;
        text-align: center;
        color: #7d3b2a;
      }
    }

    .btn-container {
      display: flex;
      justify-content: center;
      margin-top: 0.22rem;

      .btn {
        width: 0.98rem;
        height: 0.4rem;
        // margin: 0.14rem auto 0;
        background-color: #fb990f;
        border-radius: 0.32rem;
        font-weight: 600;
        font-size: 0.14rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        margin: 0 0.08rem;

        &.view {
          background-color: #fff;
          color: #a54d08;
        }

        &.share {
          background-color: #ff5729;
          color: #fff;
        }
      }
    }

    .close {
      position: absolute;
      right: 0;
      top: 0;
      width: 0.3rem;
      height: 0.3rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/Hgiou4vp_close.png);
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
}
</style>
